import { CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import CustomAlertContain from '../components/shared/CustomAlert/CustomAlertContain';
import { AlertState, CompleteOperationType, StartOperationType } from '../model/alerts.model';
import zeplinColor from '../theme/Color';

const IDLE_TIMEOUT = 5 * 1000;

export const initialAlertState: AlertState = {
  operation: null,
  status: 'idle',
  message: '',
  isError: false,
};

export const useAlertStatus = () => {
  const [alertState, setAlertState] = useState<AlertState>(initialAlertState);

  useEffect(() => {
    if (alertState.status === 'complete' || alertState.status === 'error') {
      const timer = setTimeout(() => {
        setAlertState(initialAlertState);
      }, IDLE_TIMEOUT);

      return () => clearTimeout(timer);
    }
  }, [alertState]);

  const startOperation: StartOperationType = (operation, initialMessage) => {
    setAlertState({
      operation,
      status: 'in-progress',
      message: initialMessage,
      isError: false,
    });
  };

  const completeOperation: CompleteOperationType = (operation, message, isError = false) => {
    setAlertState({
      operation,
      status: isError ? 'error' : 'complete',
      message,
      isError,
    });
  };

  const getAlertContent = (alertState: AlertState) => {
    const { status, message } = alertState;

    let icon = null;
    if (status === 'in-progress') {
      icon = <CircularProgress sx={{ color: zeplinColor.Neutral1 }} size={'18px'} />;
    } else if (status === 'complete') {
      icon = (
        <img src='/assets/checkmark-green.png' width={24} height={24} alt='Operation successful' />
      );
    } else if (status === 'error') {
      icon = <img src='/assets/error.svg' width={24} height={24} alt='error message' />;
    }

    return <CustomAlertContain alertIcon={icon} alert={message} />;
  };

  return { alertState, startOperation, completeOperation, setAlertState, getAlertContent };
};
